import React from "react";
export const FlashMessageContext = React.createContext({
    flashMessage: null,
    setFlashMessage: (flashMessage) => { },
});
